import { useAppSelector } from '@/redux/store';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '../types/contract';

import { useTimerToEnd } from './timer-to-end';

const useTimerToNextSpecContract = (
  kind: SpecContractType | PaidSpecContractType,
  callback?: () => void,
): number | null => {
  const endTime = useAppSelector(
    (state) => state.contract.nextSpecContractEndTime[kind],
  );

  return useTimerToEnd(endTime, callback);
};

export { useTimerToNextSpecContract };
